import script from "./QualityTable.vue?vue&type=script&setup=true&lang=js"
export * from "./QualityTable.vue?vue&type=script&setup=true&lang=js"

import "./QualityTable.vue?vue&type=style&index=0&id=4841db78&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\ASIC\\MulticaseVue\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4841db78"]])

export default __exports__